import React, { useState } from "react";
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import { toast } from "react-toastify";
import { externalUrl } from "../../data/externalUrls.js";
import Loading from "../../components/Loading.js";
import axios from "axios";
import CsVersionUpdate from "../../models/CsVersionUpdate.js";
import FormPartial from "./FormPartial.js";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

const Main = () => {
  const [csVersionUpdate, setCsVersionUpdate] = useState(new CsVersionUpdate());
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const onSubmit = async (params) => {
    try {
      setIsLoading(true);
      const formData = new URLSearchParams();
      formData.append('type', params.cs_version_update.type);
      formData.append('device_id', params.cs_version_update.device_id);
      formData.append('version', params.cs_version_update.version);
      formData.append('username', params.cs_version_update.username);
      formData.append('usermail', params.cs_version_update.usermail);
      formData.append('reason', params.cs_version_update.reason);

      await axios.post(`${externalUrl.flaskServiceUrl}/Version_Update/cs_version_change`, formData)
      .then((response) => {
        if(response.status === 200){
          toast.success(
            <>
              Version updated successfully.
              <br />
              Please check if updated after a while.
            </>
          );
        }
      })
      .catch(error => {
        toast.error(error?.message || 'Something went wrong!' );
      });
    } catch(error) {
      toast.error(error?.data?.message || 'Something went wrong !');
      // let csVersionUpdateObj = new CsVersionUpdate(csVersionUpdate);
      // csVersionUpdateObj.set_api_errors(error?.data?.data?.errors);
    } finally {
      handleCloseModal();
      setIsLoading(false);
    }
  }

  const onSubmitClick = () => {
    try{
      if(new CsVersionUpdate(csVersionUpdate).toApiJson()){
        handleShowModal();
      }
    } catch(error){
      setCsVersionUpdate(new CsVersionUpdate(csVersionUpdate));
    }
  }

  const onConfirmSubmitClick = () => {
    onSubmit(new CsVersionUpdate(csVersionUpdate).toApiJson())
  }

  const beautifyString = (str) => {
    return str.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.ChargingStationVersionUpdatePage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Charging Station Version Update" }]}
    className={'charging-station-version-update-page'}
  >
    <PageContentWrapper contentHeading={"Charging Station Version Update"}>
    {isLoading && <Loading />}
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
        className="text-white"
        closeButton
      >
        <Modal.Title>Charging Station Version Update</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='text-center m-2 text-warning'>
          <FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/>
        </div>
        <p className='h4 text-center my-3 opacity-75'>Are you sure ?</p>
        <p className='h6 text-center my-3 opacity-75 fw-normal'>
          You want to update below charging station/s ?
        </p>
        <div className="table-responsive custom-scrollbar border rounded p-2">
          <table className="table table-bordered border-2 border rounded">
            <thead className="table-success">
              {/* <tr>
                <th>Device ID/s</th>
                <th>Version Type</th>
                <th>Version Name</th>
                <th>Remarks/Reason</th>
              </tr> */}
            </thead>
            <tbody>
              <tr className="border">
                <td className="border ps-2 fw-bold">Device ID/s</td>
                <td className="border ps-2" style={{ width: '200px', wordWrap: 'break-word', whiteSpace: 'normal'}}>
                  {csVersionUpdate.device_ids.toString().split(',').join(', ') || '- -'}</td>
              </tr>
              <tr className="border">
                <td className="border ps-2 fw-bold">Version Type</td>
                <td className="border ps-2" style={{ width: '200px', wordWrap: 'break-word', whiteSpace: 'normal'}}>
                  {beautifyString(csVersionUpdate.type) || '- -'}</td>
              </tr>
              <tr className="border">
                <td className="border ps-2 fw-bold">Version Name</td>
                <td className="border ps-2" style={{ width: '200px', wordWrap: 'break-word', whiteSpace: 'normal'}}>
                  {csVersionUpdate.version || '- -'}</td>
              </tr>
              <tr className="border">
                <td className="border ps-2 fw-bold">Remarks/Reason</td>
                <td className="border ps-2" style={{ width: '200px', wordWrap: 'break-word', whiteSpace: 'normal'}}>
                  {csVersionUpdate.remarks || '- -'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-sm rounded-5 btn-outline-secondary"
          style={{ width: "80px", fontSize: '16px' }}
          onClick={handleCloseModal}
        >
          Cancel
        </button>
        <button
          type='submit'
          className='btn btn-sm add-button'
          style={{ width: "80px", fontSize: '16px' }}
          onClick={ (e) => {e.preventDefault(); onConfirmSubmitClick()} }
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
      <div className="m-4">
        <form className="row g-3" autoComplete="off">
          <FormPartial  csVersionUpdate={csVersionUpdate} setCsVersionUpdate={setCsVersionUpdate} setIsLoading={setIsLoading}/>
          <div className='d-flex my-3'>
            <button type="button" className="btn btn-voltup-theme my-2" onClick={onSubmitClick}>
              Submit
            </button>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Main;
